<template>
  <v-col xs="12" sm="12" md="12" lg="12">
    <v-responsive width="100%" v-if="$vuetify.breakpoint.xsOnly" />
    <br>
    <v-card elevation="5" rounded>
      <v-row class="mx-1 mb-1">
        <v-col xs="12" sm="12" md="2" lg="2">
          <v-text-field type="date" label="From date" outlined dense v-model="search.start_date">
          </v-text-field>
        </v-col>
        <v-col xs="12" sm="12" md="2" lg="2">
          <v-text-field type="date" label="End date" outlined dense v-model="search.end_date">
          </v-text-field>
        </v-col>
        <v-col xs="12" sm="12" md="2" lg="2">
          <v-select :items="status" outlined dense label="Status" v-model="search.status"></v-select>
        </v-col>
        <v-col xs="12" sm="12" md="2" lg="2" v-if="(ROLE == 'Owner')">
          <v-select :items="branch.data" item-text="name" item-value="id" outlined dense label="Branch"
            v-model="search.branch_id"></v-select>
        </v-col>
        <v-col xs="12" sm="12" md="2" lg="2">
          <v-text-field label="Search" outlined dense v-model="search.search">
          </v-text-field>
        </v-col>
        <v-col xs="12" sm="12" md="2" lg="2">
          <v-btn small color="darkblue" class="white--text mx-1" @click.stop="init">Submit <v-icon
              right>mdi-magnify</v-icon></v-btn>
          <v-btn small color="secondary" class="white--text mx-1" @click.stop="clear">Clear
            <v-icon right>mdi-close-circle-multiple </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table :loading="loading" :headers="headers" :items="BranchSalesOrders.data" class="elevation-1"
        hide-default-footer>
        <template slot="body.append">
          <tr>
            <th colspan="9"></th>
            <th style="font-size: 15px;">{{ sumField('grand_total') | currency("", 0, { symbolOnLeft: false, }) }}</th>
          </tr>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-chip color="primary" small v-if="item.status == 'ONPROGRESS'">
            ON PROGRESS
          </v-chip>
          <v-chip color="success" small v-else-if="item.status == 'DONE'">
            DONE
          </v-chip>
          <v-chip color="danger" small v-else-if="item.status == 'CANCEL'">
            CANCEL
          </v-chip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip color="dark" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mr-2" color="primary" v-bind="attrs" icon small @click.stop="view(item.id)" v-on="on">
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </template>
            <span>View Sales Order</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.bill_no`]="{ item }">
          <b v-if="item.bill_no">{{ item.bill_no }}</b>
          <b v-else>-</b>
        </template>
        <template v-slot:[`item.subtotal`]="{ item }">
          <b>{{ item.subtotal | currency("", 0, { symbolOnLeft: false, }) }}</b>
        </template>
        <template v-slot:[`item.pph`]="{ item }">
          <b>{{ item.pph | currency("", 0, { symbolOnLeft: false, }) }}</b>
        </template>
        <template v-slot:[`item.vat`]="{ item }">
          <b>{{ item.vat | currency("", 0, { symbolOnLeft: false, }) }}</b>
        </template>
        <template v-slot:[`item.discount_amount`]="{ item }">
          <b>{{ item.discount_amount | currency("", 0, { symbolOnLeft: false, }) }}</b>
        </template>
        <template v-slot:[`item.grandtotal`]="{ item }">
          <b>{{ item.subtotal + item.pph + item.vat - item.discount_amount | currency("", 0, { symbolOnLeft: false, })
          }}</b>
        </template>
      </v-data-table>
      <v-pagination v-model="currentPage" :length="lastPage" :total-visible="10" :disabled="disabled">
      </v-pagination>
    </v-card>
  </v-col>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "BranchSalesOrderList",
  data() {
    return {
      headers: [
        { text: "No.Order", value: "no_so" },
        { text: "No. Bill", value: "bill_no" },
        { text: "Branch", value: "branch.name" },
        { text: "Member", value: "customer.name" },
        { text: "Order Date", value: "order_date" },
        { text: "Sub Total", value: "subtotal" },
        { text: "Pph", value: "pph" },
        { text: "Vat", value: "vat" },
        { text: "Discount", value: "discount_amount" },
        { text: "Grand Total", value: "grandtotal" },
        { text: "Status", value: "status" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      disabled: false,
      loading: false,
      branch: [],
      page: 1,
      loading_download: false,
      flag: null,
      status: [
        { text: "ALL", value: "" },
        { text: "ON PROGRESS", value: "ONPROGRESS" },
        { text: "DONE", value: "DONE" },
        { text: "CANCEL", value: "CANCEL" },
      ],
      grand_total: 0,
      search: {
        start_date: `${new Date().getFullYear()}-${("0" + (new Date().getMonth() + 1)).slice(-2)}-01`,
        end_date: new Date().toJSON().slice(0, 10),
        search: null,
        status: "",
        branch_id: null,
      },
    };
  },
  methods: {
    ...mapMutations("branch_sales_order", ["SET_BRANCH_SALES_ORDERS", "SET_CURRENT_PAGE_LIST"]),

    sumField(key) {
      return this.BranchSalesOrders.data.reduce((a, b) => a + (b[key] || 0), 0)
    },
    async init() {
      this.loading = true;
      this.disabled = true;
      let params = {
        page: this.page,
        start_date: this.search.start_date,
        end_date: this.search.end_date,
        branch_id: this.search.branch_id,
        status: this.search.status,
        search: this.search.search,
      };

      await this.$axios
        .get("/transaction/sales-orders-branch", {
          params: params,
          headers: {
            Authorization: this.$store.getters["auth/Token"],
          },
        })
        .then(({ data }) => {
          this.SET_BRANCH_SALES_ORDERS(data.sales_orders);
          this.loading = false;
          this.disabled = false;
        });
    },

    async getBranch() {
      await this.$axios
        .get("/master/branches", {
          headers: {
            Authorization: this.$store.getters["auth/Token"],
          },
        })
        .then(({ data }) => {
          this.branch = data.branch;
        });
    },

    view(id) {
      console.log(id);
      this.$router.push("/branch-sales-order/view/" + id);
    },

    searching() {
      this.page = 1;
      this.init();
    },
    clear() {
      this.search = {
        status: "",
        search: "",
        branch_id: "",
        start_date: `${new Date().getFullYear()}-${("0" + (new Date().getMonth() + 1)).slice(-2)}-01`,
        end_date: new Date().toJSON().slice(0, 10),
      };
      this.init();
    },
  },

  created() {
    this.init();
    this.getBranch();
  },

  watch: {
    currentPage(newValue) {
      this.page = newValue;
      this.init();
    },
  },
  computed: {
    ...mapGetters("branch_sales_order", {
      BranchSalesOrders: "BranchSalesOrders",
    }),

    ...mapGetters("auth", {
      ROLE: "Role",
    }),


    currentPage: {
      get() {
        return this.BranchSalesOrders.current_page;
      },
      set(val) {
        return this.$store.commit("branch_sales_order/SET_CURRENT_PAGE_LIST", val);
      },
    },
    lastPage: {
      get() {
        return this.BranchSalesOrders.last_page;
      },
    },
  },
};
</script>
<style scoped>
::v-deep .v-data-table-header {
  background-color: #ebebeb59;
}

::v-deep th {
  color: #000 !important;
}
</style>